import { MenuBookOutlined } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import React from 'react';

const UserGuideButton = () => {
  return (
    <div><Tooltip title={"User Guide"}>
      <Box
        className={`cursor-pointer ${false ? 'primary-p10' : 'neutral-n10'
          }`}
        onClick={() => {
          const a = document.createElement("a");
          a.href = `${window.location?.origin}/user-guide`;
          a.target = "_blank";
          a?.click();
          a?.remove();
        }}
        sx={{
          bgcolor: false ? 'secondary.light' : '',
          ":hover": {
            backgroundColor: 'secondary.light'
          }
        }}
      >
        <Box>{<MenuBookOutlined />}</Box>
      </Box>
    </Tooltip></div>
  );
};

export default UserGuideButton;